<template>
  <div v-if="(isQueueSettingError || isWaitingDisabled)" class="queue-disabled" :class="{'use-custom-color': useCustomColor}" v-html="queueDisabledText"></div>
  <div v-else class="card-wrap" :class="{[currentLocale]: currentLocale}">
    <div v-for="(queue) in queueList" :key="queue.index" class="queue-card" :class="{ disabled: queue.isClosed, medium: queueList.length === 3, small: queueList.length === 4 }">
      <div class="name" :class="{[currentLocale]: currentLocale}">
        <text-ellipsis line="2" customClass="queue-name-ellipsis">
          <span class="queue-name-text">{{ getQueueName(queue) }}</span>
        </text-ellipsis>
      </div>
      <div v-if="queue.isClosed" class="closed-wrap">{{ $tc('home_08_queueDisbled') }}</div>
      <div class="queue-cnt-wrap" :class="{ tooLongNumber: queue.count > 999, [currentLocale]: currentLocale }">
        <div class="cnt">{{ queue.count }}</div>
        <div class="text">{{ $tc('home_06_queueCountText') }}</div>
      </div>
      <div class="button" @click="useQueueWaiting(queue)">
        <span>{{ $tc('home_07_queueStart') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { textEllipsis } from '@/components/text'
import { getMultiLanguageName } from '@/utills'
import { mapGetters } from 'vuex'

export default {
  name: 'queue-card',
  components: {
    textEllipsis
  },
  props: {
    queueList: { type: Array, default: () => [] },
    isWaitingDisabled: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters(['getStoreIdx']),
    // 리뉴얼 컬러 예외매장 여부 - 우래옥
    useCustomColor () {
      return (process.env.VUE_APP_CUSTOM_COLOR && process.env.VUE_APP_CUSTOM_COLOR.includes(this.getStoreIdx))
    },
    // 대기열 사용 불가 시 노출될 텍스트
    queueDisabledText () {
      return (this.isQueueSettingError) ? this.$tc('home_05_queueSettingError') : this.$tc('home_04_emptyMenuList')
    },
    // 대기열 설정 정상 여부
    isQueueSettingError () {
      return (this.queueList.length < 2 || this.queueList.length > 4)
    },
    currentLocale () {
      return this.$store.state.locale
    }
  },
  methods: {
    /**
     * @description 대기열 사용 줄서기
     * @param {Object} queue
     * @returns {void}
     */
    useQueueWaiting (queue) {
      this.$emit('useQueueWaiting', queue)
    },
    /**
     * @description 대기열 이름 가져오기 (다국어 지원)
     * @param {Object} queue
     * @returns {string}
     */
    getQueueName (queue) {
      const currentLocale = this.$store.state.locale
      return getMultiLanguageName(queue, currentLocale)
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/base.scss";
// 대기 불가 상태
.queue-disabled {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 43.25vh;
  border-radius: 2.5vh;
  background: #2E3137;
  font-size: 50px; // IE11 fallback
  font-size: unquote("min(3.90625vw, 50px)");
  font-weight: 700;
  text-align: center;
  line-height: 9.25vh;
  color: $white;
}
// 대기열 카드
.card-wrap {
  display: flex;
  @include flex-gap(2.5vh, row);
  .queue-card {
    display: flex;
    padding: 3vh 1.875vw;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-height: 47.75vh;
    border-radius: 3vh;
    background: #FFF;
    flex: 1 1 0;
    min-width: 0;
    .name {
      display: flex;
      align-items: center;
      height: 9.5vh;
      word-break: break-all;
      text-align: center;
      font-size: 38px; // IE11 fallback
      font-size: unquote("min(2.969vw, 38px)");
      font-weight: 700;
      line-height: 1.13;
      color: #000;
      overflow: hidden;
      .queue-name-ellipsis.multiline_2 {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
      .queue-name-ellipsis.multiline_2 .queue-name-text {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        line-height: 1.2em;
        max-height: 2.4em;
        width: 100%;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        text-align: center;
      }
    }
    .queue-cnt-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0 3vh;
      color: #D81B1B;
      font-weight: 800;
      text-align: center;
      .cnt {
        font-size: 110px; // IE11 fallback
        font-size: unquote("min(8.59375vw, 110px)");
        line-height: 95px;
      }
      .text {
        margin-left: 0.3125vw;
        font-size: 85px; // IE11 fallback
        font-size: unquote("min(6.640625vw, 85px)");
        line-height: 1;
      }
    }
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      @include flex-gap(1.25vh, row);
      width: 100%;
      height: 10.5vh;
      border-radius: 2vh;
      background: #D81B1B;
      color: $white;
      cursor: pointer;
      span {
        font-size: 32px; // IE11 fallback
        font-size: unquote("min(2.5vw, 32px)");
        font-weight: 700;
        line-height: 4.75vh;
      }
    }
    &.medium, &.small { // 대기열 3개, 4개
      .name {
        // font-size: 36px; // IE11 fallback
        // font-size: unquote("min(2.8125vw, 36px)");
      }
    }
    &.small {
      padding: 2.5vh 1.5625vw;
      .name {
        font-size: 32px; // IE11 fallback
        font-size: unquote("min(2.5vw, 32px)");
        line-height: 1.12;
      }
      .queue-cnt-wrap {
        .cnt {
          font-size: 85px; // IE11 fallback
          font-size: unquote("min(6.640625vw, 85px)");
        }
        .text {
          font-size: 72px; // IE11 fallback
          font-size: unquote("min(5.625vw, 72px)");
          line-height: 12.5vh;
        }
      }
    }
  }
  .disabled {
    background: $gray_700;
    justify-content: flex-start;
    // gap: 6.875vh;
    .name {
      flex-shrink: 0;
      color: $gray_400;
    }
    .closed-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 0 0 20px 0;
      color: #969FAC;
      text-align: center;
      font-size: 110px; // IE11 fallback
      font-size: unquote("min(8.59375vw, 110px)");
      font-weight: 800;
      line-height: 0.863;
    }
    &.medium {
      .closed-wrap {
        font-size: 85px; // IE11 fallback
        font-size: unquote("min(6.640625vw, 85px)");
      }
    }
    &.small {
      .closed-wrap {
        font-size: 62px; // IE11 fallback
        font-size: unquote("min(4.84375vw, 62px)");
      }
    }
    .queue-cnt-wrap, .button {
      display: none;
    }
  }
  &.en {
    .queue-card {
      .name {
        // font-size: 36px; // IE11 fallback
        // font-size: unquote("min(2.8125vw, 36px)");
        // line-height: 1.11;
      }
      .queue-cnt-wrap {
        align-items: baseline;
        padding: 0 0 18px;
        .text {
          margin-left: 8px;
          font-size: unquote("min(3.90625vw, 50px)");
          line-height: 80px;
          font-weight: 700;
        }
        &.disabled {
          .closed-wrap {
            font-size: 100px; // IE11 fallback
            font-size: unquote("min(7.8125vw, 100px)");
            line-height: 1.05;
          }
        }
      }
      &.medium, &.small {
        .queue-cnt-wrap {
          align-items: center;
          flex-direction: column;
          @include flex-gap(1vh, column);
          padding: 0;
          .cnt {
            font-size: 85px; // IE11 fallback
            font-size: unquote("min(6.640625vw, 85px)");
            line-height: 1;
          }
          .text {
            font-size: 36px; // IE11 fallback
            font-size: unquote("min(2.8125vw, 36px)");
            line-height: 5vh;
          }
        }
      }
    }
  }
  &.jp, &.cn_simplified {
    .queue-card {
      .name {
        // font-size: 36px; // IE11 fallback
        // font-size: unquote("min(2.8125vw, 36px)");
        // line-height: 1.11;
      }
      .queue-cnt-wrap {
        flex-direction: column;
        @include flex-gap(1vh, column);
        .cnt {
          font-size: 100px; // IE11 fallback
          font-size: unquote("min(7.8125vw, 100px)");
          line-height: 1;
        }
        .text {
          font-size: 32px; // IE11 fallback
          font-size: unquote("min(2.5vw, 32px)");
          line-height: 5vh;
        }
        &.disabled {
          .closed-wrap {
            font-size: 100px; // IE11 fallback
            font-size: unquote("min(7.8125vw, 100px)");
            line-height: 1.05;
          }
        }
      }
      &.medium, &.small {
        align-items: center;
        flex-direction: column;
        @include flex-gap(1vh, column);
        .queue-cnt-wrap {
          padding: 0;
        }
        .cnt {
          font-size: 85px; // IE11 fallback
          font-size: unquote("min(6.640625vw, 85px)");
          line-height: 1;
        }
        .text {
          font-size: 36px; // IE11 fallback
          font-size: unquote("min(2.8125vw, 36px)");
          line-height: 1.2;
        }
      }
    }
  }
}
// 리뉴얼 컬러 예외매장 스타일 : 아직 대기열은 디자인이 미정이라 추후 수정 필요
// .use-custom-color {}
</style>
